import { AxiosError } from 'axios'
import { makeAutoObservable, toJS } from 'mobx'

import { selectionStore } from 'entities/tour/models'
import tourList from 'entities/tour/models/tour-list/tour-list.ts'

import { HotTour, Hotel, SearchToursApi } from 'shared/api/tours/search'

class HotTourStore {
  hotToursList: HotTour[] = []
  isLoading: boolean = false
  isError: boolean = false
  hotTourDetail: Hotel | null = null
  abortController: AbortController | null = null

  constructor() {
    makeAutoObservable(this)
  }

  async requestHotToursList(townFromId?: string) {
    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    const signal = this.abortController.signal

    try {
      this.isLoading = true
      this.isError = false

      const { data: toursData } = await SearchToursApi.getHotTours(
        townFromId,
        signal,
      )

      this.hotToursList = toursData?.data || []
    } catch (err) {
      if (
        err instanceof AxiosError &&
        (err.code === 'ERR_CANCELED' || err.name === 'CanceledError')
      ) {
        return
      }
      this.isError = true
    } finally {
      if (!signal.aborted) {
        this.isLoading = false
      }
    }
  }

  getHotTourList() {
    return toJS(this.hotToursList)
  }

  async requestHotTourDetail(tourId?: string) {
    try {
      this.isError = false
      this.isLoading = true

      const { data: toursData } = await SearchToursApi.getHotTourDetail(tourId)

      this.hotTourDetail = toursData?.data

      const hotelSearchSessionId = toursData?.data?.request_params?.uid

      selectionStore.setSelectedHotel(toursData?.data)

      if (hotelSearchSessionId) {
        tourList.setUid(hotelSearchSessionId)
      }
    } catch {
      this.isError = true
    } finally {
      this.isLoading = false
    }
  }

  getTourDetail() {
    return toJS(this.hotTourDetail)
  }

  removeTourDetail() {
    this.hotTourDetail = null
  }
}

export default new HotTourStore()
